import React from "react";
import { useSelector } from "react-redux";
import { Body2, Dot, Header2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { CompanyNameContainer } from "~/components/Companies/CompanyNameContainer";
import { EntityLink } from "~/components/EntityLink";
import ProjectName from "~/components/project/ProjectName";
import { getCalendarAssigments } from "~/store/selectors/selector.calendars";
import { CalendarGhostTaskItem } from "./CalendarGhostTaskItem";
import { CalendarSubtaskItem } from "./CalendarSubtaskItem";
import { CalendarTaskItem } from "./CalendarTaskItem";
import { useCalendarContext } from "../CalendarContext";

export const CalendarTasks = ({ children }) => {
  const { selectedDate } = useCalendarContext();
  const tasksByProject = useSelector((state) => getCalendarAssigments(state, selectedDate));
  if (tasksByProject.length === 0) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-w-full">
      {children}
      <div className="tw-flex tw-flex-col tw-gap-6">
        {tasksByProject.map((item) => (
          <div
            key={`project-id-${item.id}`}
            className="tw-flex tw-flex-col tw-w-full"
          >
            <div className="tw-truncate tw-flex tw-items-center tw-h-8">
              <Header2
                as={EntityLink}
                to={item.url_path}
                color="theme-primary"
                className="tw-truncate tw-max-w-[340px] hover:tw-underline"
              >
                <ProjectName id={item.id} />
              </Header2>
              <div className="tw-px-[6px] tw-flex tw-justify-center tw-items-center">
                <Dot
                  color="#89898E"
                  size={4}
                />
              </div>
              <Body2
                color="tertiary"
                weight="medium"
                className="tw-truncate tw-max-w-[340px]"
              >
                <CompanyNameContainer id={item.company_id} />
              </Body2>
            </div>
            {item.tasks.length > 0
              ? item.tasks.map((id) => (
                  <CalendarTaskItem
                    key={`task-${id}`}
                    id={id}
                  />
                ))
              : null}
            {item.subtasks.length > 0
              ? item.subtasks.map((id) => (
                  <CalendarSubtaskItem
                    key={`task-${id}`}
                    id={id}
                  />
                ))
              : null}
            {item.ghostTasks.length > 0
              ? item.ghostTasks.map((ghostTaskId) => (
                  <CalendarGhostTaskItem
                    key={`ghost-task-${ghostTaskId}`}
                    id={ghostTaskId}
                  />
                ))
              : null}
          </div>
        ))}
      </div>
    </div>
  );
};

CalendarTasks.propTypes = {
  children: PropTypes.node,
};
